module.exports = __webpack_public_path__ + "static/media/backward_blue.14142529.svg";